import React from "react";
import MDBox from "components/MDBox";
import Slide41 from "assets/images/TheSolutionImages/Slide4/Slide41.png";

function Slide4() {
  return (
    <MDBox textAlign="center" px={{ xs: 2, sm: 4, md: 6 }}>
      {/* Title Bar */}
      <h1
        style={{
          color: "white",
          fontSize: "32px",
          marginBottom: "20px",
        }}
      >
        Web of SSLD Coverage
      </h1>

      {/* Main Text + Image */}
      <MDBox fontSize={{ xs: "18px", md: "24px" }} mb={7} color="#FFFFFF">
        {/* Text Block */}
        <MDBox mb={4} style={{ fontSize: "24px" }}>
          <div style={{ marginBottom: "12px", color: "white" }}>
            SharpWatch® applies patented Algorithms
          </div>
          <div style={{ marginBottom: "12px", color: "white" }}>
            SharpWatch® integrates the modules together to form a web of SSLD coverage
          </div>
        </MDBox>

        {/* Image */}
        <MDBox display="flex" justifyContent="center">
          <img
            src={Slide41}
            alt="Web of SSLD Coverage"
            style={{
              width: "100%",
              maxWidth: "600px",
              height: "auto",
            }}
          />
        </MDBox>
      </MDBox>
    </MDBox>
  );
}

export default Slide4;
